import ReactDOM from 'react-dom/client';
import { App } from './app';
import './main.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />
);
